export enum RecipientField {
  id = 'id',
  uuid = 'uuid',
  name = 'name',
  priority = 'priority',
  category = 'category',
  createdAt = 'createdAt',
  description = 'description',
}
